var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('modal-dialog',{scopedSlots:_vm._u([{key:"trigger",fn:function(ref){
var openModal = ref.openModal;
return [_c('a',{staticClass:"btn-link size-14 weight-normal",on:{"click":function($event){$event.preventDefault();return openModal($event)}}},[_vm._v(" ver detalhes ")])]}}])},[_c('template',{attrs:{"item":_vm.item},slot:"body"},[_vm._t("detail",null,{"item":_vm.item})],2)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }